import service from "@/services/buildings";

const building = {
  namespaced: true,
  state: {
    buildings: [],
    meetingId: null,
    participation: [],
    apartments_with_participation: [],
  },

  getters: {
    getBuildings: (state) => {
      return state.buildings;
    },

    getUnVotedApartments: (state) => (changePaperVote) => {
      // let voted = state.participation;
      // const requiresSigning = rootGetters["meeting/needsDigitalSignature"];
      //
      // function hasValidParticipation(id) {
      //   return voted.some((vote) => {
      //     const hasPartisipate = vote.cooperative_apartment_id === id;
      //
      //     if (hasPartisipate === false) {
      //       return false;
      //     }
      //     if (requiresSigning === false) {
      //       return true;
      //     }
      //     // change paper vote
      //     // if (vote.paper_vote && changePaperVote) {
      //     //   return false;
      //     // }
      //     return vote.all_signed;
      //   });
      // }

      return state.buildings.reduce((total, building) => {
        building.apartments.forEach((apartment) => {
          const { name, id, owners } = apartment;
          let text = name;
          if (state.buildings.length > 1) {
            text = `${building.name}-${name}`;
          }
          if (changePaperVote) {
            if (owners.length >= 1) {
              total.push({
                text,
                value: id,
              });
            }
          } else if (owners.length >= 1) {
            total.push({
              text,
              value: id,
            });
          }
        });
        return total;
      }, []);
    },

    getOwners: (state) => (id) => {
      let ownersList = [];
      state.buildings.forEach((ap) =>
        ap.apartments
          .filter((o) => o.id === Number(id))
          .map((owner) =>
            owner.owners.forEach((name) => {
              let text = name.first_name + " " + name.last_name;
              if (name.company_name !== null) {
                text = ` ${name.first_name}`;
              }
              let ownerObj = {
                text: text,
                value: name.user_id,
              };
              ownersList.push(ownerObj);
            })
          )
      );
      return ownersList;
    },

    getContactsWithoutEmail: (state) => {
      return state.buildings.reduce((total, current) => {
        const { name, apartments } = current;
        apartments.forEach((apartment) => {
          if (apartment.owners.length > 0) {
            const entry = {
              building: name,
              apartment: apartment.name,
              owners_name: apartment.owners
                .map(
                  ({ first_name, last_name }) => `${first_name} ${last_name}`
                )
                .join(", "),
              phone: apartment.owners.map(({ phone }) => phone).join(", "),
              email: apartment.owners.map(({ email }) => email).join(", "),
            };

            if (entry.email.length === 0) {
              total.push(entry);
            }
          }
        });

        return total;
      }, []);
    },
    getApartmentsWithParticipation: (state) => {
      return state.apartments_with_participation;
    },
    getParticipation: (state) => {
      return state.participation;
    },
  },

  mutations: {
    setData(state, data) {
      state.buildings = [...data];
    },
    setMeetingId(state, id) {
      state.meetingId = id;
    },
    setParticipation(state, participation) {
      state.participation = participation;
    },
    mergeApartmentsWithParticipation(state) {
      state.apartments_with_participation = state.buildings.map((building) => {
        building.apartments.map((apartment) => {
          const { id } = apartment;

          apartment.owners = apartment.owners.map((owner) => {
            const ownerVote = state.participation.find(
              ({ cooperative_apartment_id, user_id }) =>
                cooperative_apartment_id === id && user_id === owner.user_id
            );
            return { ...owner, voted: ownerVote };
          });

          const matchApartment = state.participation.filter(
            ({ cooperative_apartment_id }) => cooperative_apartment_id === id
          );

          apartment.voted = matchApartment || [];

          return apartment;
        });
        return building;
      });
    },
  },

  actions: {
    async fetchBuildings({ dispatch }, meetingId) {
      try {
        const data = await service.getBuildings(meetingId);
        // const data = await service.getMeetings(meetingId);
        dispatch("initData", { meetingId, data });
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchParticipation({ commit }, meetingId) {
      try {
        const participation = await service.getParticipation(meetingId);
        commit("setParticipation", participation);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async fetchApartmentsWithParticipation({ dispatch, commit }, meetingId) {
      try {
        await Promise.all([
          dispatch("fetchBuildings", meetingId),
          dispatch("fetchParticipation", meetingId),
        ]);
        commit("mergeApartmentsWithParticipation");
      } catch (e) {
        console.error(e);
      }
    },

    initData({ commit }, { meetingId, data }) {
      commit("setMeetingId", meetingId);
      commit("setData", data);
    },
  },
};
export default building;
